<template>
    <div v-if="showInfoModal">
        <div class="popupModal" :class="{active: showInfoModal}">
            <div class="popupModal__wrapper" @mousedown = 'underlayClick'>
                <div class="popupModal__content" id="popupModal__content">
                    <div>
                        <span class="close-icon" @click="onClose">
                        </span>
                    </div>

                    <div class="place img_wrapper">
                        <div class="place_img_ga">
                            <div v-if="giveaway.giveaway_title == 'jbar'">
                                <img src="@/assets/icons/jbar-logo.png" alt="place img">
                            </div>
                            <div v-if="giveaway.giveaway_title == 'm&k'">
                                <img src="@/assets/icons/m&k_logo.png" alt="place img">
                            </div>
                            <div v-if="giveaway.giveaway_title == 'wasted'">
                                <img src="@/assets/icons/wasted_logo.jpg" alt="place img">
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="giveaway__wrapper" v-if="!giveaway.participates && !redirectToSocialMode">
                            <div v-if="giveaway.giveaway_title == 'jbar'">
                                <div class="giveaway__title">{{ translate('ambassadorPopup_title') }}</div>
                                <div class="giveaway-checkList">
                                    <div class="checkList__wrapper">
                                        <div class="checkList__content">
                                            <div class="content__number">
                                                1
                                            </div>
                                            <div class="content__text">{{ translate('ambassadorPopup_votes') }}</div>
                                        </div>
                                        <div class="checkList__content">
                                            <div class="content__number">
                                                2
                                            </div>
                                            <div class="content__text">{{ translate('ambassadorPopup_review') }}
                                            </div>
                                        </div>
                                        <div class="checkList__description">
                                            {{ translate('ambassadorDescription') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="giveaway.giveaway_title == 'm&k'">
                                <div class="giveaway__title">To join the contest, just tell us who you are and keep voting</div>
                                <div class="giveaway-checkList">
                                    <div class="description_text">
                                        Every time you tell us the condition of our restrooms, you get entered into our giveaway contest. The winner gets $150 cash! Enter your phone number for your chance to win.
                                    </div>
                                    <div class="description_text" style="font-size: 14px; margin-top: 4px;">
                                        (limit one per location per hour)
                                    </div>
                                    <div class="description_text" style="margin-top: 18px; margin-bottom: 18px;">
                                        Help us know the condition of our restrooms to keep them clean for the users.
                                    </div>
                                </div>
                            </div>
                            <div v-if="giveaway.giveaway_title == 'wasted'">
                                <div class="giveaway__title">To join the contest, just tell us who you are and keep voting</div>
                                <div class="giveaway-checkList">
                                    <div class="description_text">
                                        Every time you tell us about the condition of Wasted* restroom, you get another
                                        chance in our giveaway contest. The winner gets $50 gift card!
                                    </div>
                                    <div class="description_text" style="font-size: 14px; margin-top: 4px;">
                                        (limit one per location per hour)
                                    </div>
                                    <div class="description_text" style="margin-top: 18px; margin-bottom: 18px;">
                                        Help us succeed together!
                                    </div>
                                </div>
                            </div>
                            <div class="giveaway-login">
                                <div class="login__wrapper" v-if="!accessToken">
                                    <div class="login__title" v-if="giveaway.giveaway_title == 'jbar'">{{translate('ambassadorPopup_BtnLogin')}}</div>
<!--                                    <div class="login__title" v-if="giveaway.giveaway_title == 'm&k'">Count me in!</div>-->
                                    <div v-if="(giveaway.giveaway_title == 'm&k' || giveaway.giveaway_title == 'wasted') && !phoneNumberSent">
                                        <div class="step_hint">First, please enter your phone #</div>
                                        <div class="phone_input_wrapper">
                                            <input placeholder="Phone number" class="phone_input"
                                                   v-model="phoneNumber">
                                            <div class="phone_save" @click="onSendPhoneClick"><span>Send</span></div>
                                        </div>
                                    </div>
<!--                                    <div class="step_hint small" v-if="giveaway.giveaway_title == 'm&k' && phoneNumberSent">Next, sign in with google or facebook</div>-->
                                    <div class="loginBtn" v-if="giveaway.giveaway_title != 'm&k' || giveaway.giveaway_title != 'wasted'">
                                        <div class="loginBtnFacebook__wrapper" @click="onFacebookSignIn">
                                            <div class="loginBtn__icon">
                                                <img src="@/assets/icons/ic_facebook_logo.svg">
                                            </div>
                                            <div class="loginBtn__text">Facebook</div>
                                        </div>
                                        <div class="loginBtnGoogle__wrapper" @click="onGoogleSingIn">
                                            <div class="loginBtn__icon">
                                                <img src="@/assets/icons/ic_google_logo.svg">
                                            </div>
                                            <div class="loginBtn__text">Google</div>
                                        </div>
                                        <v-facebook-login @sdk-init="sdkLoaded" app-id="770275700057951"
                                                          hidden></v-facebook-login>
                                    </div>
                                </div>
                            </div>
                            <div class="giveaway-cancel">
                                <div class="cancel__wrapper" @click="onClose">
                                    <div class="cancel__text">{{translate('ambassadorPopup_cancel')}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="!redirectToSocialMode">
<!--                            <div class="giveaway__title">{{translate('giveawayBottomFinish_title')}}</div>-->
                            <div class="finalStep">
                                <div v-if="giveaway.giveaway_title == 'jbar'">
                                    <div class="ambassador-benefits">
                                        {{ translate('ambassadorFinishTitle') }}
                                    </div>
                                    <div class="giveaway-checkList">
                                        <div class="checkList__wrapper">
                                            <div class="checkList__content">
                                                <div class="content__number">
                                                    1
                                                </div>
                                                <div class="content__text">{{ translate('ambassadorMonthlyDrawing') }}
                                                </div>
                                            </div>
                                            <div class="checkList__content">
                                                <div class="content__number">
                                                    2
                                                </div>
                                                <div class="content__text">
                                                    {{ translate('ambassadorReceive') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ambassador-help">
                                        Help us succeed together!
                                    </div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'm&k'">
                                    <div class="ambassador-benefits">M&K contest rules</div>
                                    <div class="giveaway-checkList">
                                        <div class="description_text" style="margin-top: 12px; margin-bottom: 12px; text-decoration: underline;">
                                            You have been entered into the contest
                                        </div>
                                        <div class="description_text">
                                            Every time you tell us the condition of our restrooms, you get entered into our giveaway contest. The winner gets $150 cash!
                                        </div>
                                        <div class="description_text" style="font-size: 14px; margin-top: 4px;">
                                            (limit one per location per hour)
                                        </div>
                                        <div class="description_text" style="margin-top: 24px; margin-bottom: 24px;">
                                            Help us know the condition of our restrooms to keep them clean for the users.
                                        </div>
                                    </div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'wasted'">
                                    <div class="ambassador-benefits">Wasted* contest rules</div>
                                    <div class="giveaway-checkList">
                                        <div class="description_text" style="margin-top: 12px; margin-bottom: 12px; text-decoration: underline;">
                                            You have been entered into the contest
                                        </div>
                                        <div class="description_text">
                                            Every time you tell us about the condition of Wasted* restroom, you get another
                                            chance in our giveaway contest. The winner gets $50 gift card!
                                        </div>
                                        <div class="description_text" style="font-size: 14px; margin-top: 4px;">
                                            (limit one per location per hour)
                                        </div>
                                        <div class="description_text" style="margin-top: 24px; margin-bottom: 24px;">
                                            Help us succeed together!
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="closeBtn" @click="onClose">
                                <div class="closeBtn__text">
                                    {{translate('Close')}}
                                </div>
                            </div>
                        </div>
<!--                        <div v-else-if="redirectToSocialMode">-->
<!--                            <div class="giveaway__title">{{translate('giveawayBottomFinish_title')}}</div>-->
<!--                            <div class="finalStep">-->
<!--                                <div class="finalStep__text">-->
<!--                                    {{translate('giveawayPopup_finalStep')}}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div @click="confirmRedirectToSocial" class="closeBtn">-->
<!--                                <div class="closeBtn__text">-->
<!--                                    {{translate('giveawayPopup_proceedReview')}}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>

                    <template>
                        <button v-if="settings.showCancelButton" variant="default" class="secondary" @click="onClose">
                            <template v-if="settings.cancelButtonText">{{ settings.cancelButtonText }}</template>
                            <template v-else>{{ translate('Cancel') }}</template>
                        </button>

                        <button v-if="settings.showAdditionalButton" variant="success" class="btn-primary"
                                  @click="onAdditional">
                            <template v-if="settings.additionalButtonText">{{ settings.additionalButtonText }}</template>
                            <template v-else>Additional</template>
                        </button>

                        <button v-if="!settings.hideOkButton" class="btn-primary" variant="primary" @click="onOk">
                            <template v-if="settings.okButtonText">{{ settings.okButtonText }}</template>
                            <template v-else>{{translate('OK')}}</template>
                        </button>
                    </template>
                </div>
            </div>
        </div >

    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import rateMixin from '@/mixins/rateMixin';
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import logAnalyticsEvent from '@/helpers/analytics'
import {VFBLogin as VFacebookLogin} from 'vue-facebook-login-component'

export default {
        name: "giveawayModal",

        mixins: [mixin, errorMixin, rateMixin],

        data() {
            return {
                showInfoModal: this.settings !== null,
                place_img: '',
                redirectToSocialMode: null,
                phoneNumberSent: false,
                phoneNumber: '',
            }
        },
        components: {
            VFacebookLogin,
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = newValue !== null
             }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        async mounted() {
            if(this.giveaway.participates) {
                logAnalyticsEvent('giveaway_displayed_participates')
            } else {
                logAnalyticsEvent('giveaway_displayed_new')
            }
        },
        computed: {
            ...mapGetters({
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                getOwnPlace: 'auth/getOwnPlace',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                getFormatedLang: 'getFormatedLang',
                giveaway: 'rate/getGiveaway',
            }),
            ...mapState({
                accessToken: state => state.auth.accessToken,
                anonymousToken: state => state.auth.anonymousToken,
                voted: state => state.voted,
                userInfo: state => state.auth.userInfo
            })
        },


        methods: {
            ...mapActions({
                logIn: 'auth/logIn',
                fetchUserInfo: 'auth/fetchUserInfo',
                getRateInfoAction: 'rate/getRateInfo',
                sendContactInfo: 'comment/sendContactInfo',
            }),
            ...mapMutations({
                setProgressBarTag: 'setProgressBarTag'
            }),

            getIconStyle() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.settings.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },

            async onClose() {
                logAnalyticsEvent('giveaway_close_click')
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onOk() {
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            onAdditional() {
                this.showInfoModal = false
                if (this.settings.onAdditionalHandler) {
                    this.settings.onAdditionalHandler(this.settings)
                }
            },
            async onSendPhoneClick() {
                if(this.phoneNumber.length < 6) {
                    this.showErrorModal('Please enter your phone number')
                    return
                }
                this.setProgressBarTag({
                    show: true,
                    tag: 'send_phone'
                })
                try{
                    let response = await this.sendContactInfo({
                        voteId: this.settings.currentVoteUid,
                        contactInfo: this.phoneNumber,
                    })
                    this.phoneNumberSent = true
                    if (this.settings.onPhoneSentHandler) {
                        await this.settings.onPhoneSentHandler(this.settings)
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'send_phone'
                    })
                }

            },
            async onGoogleSingIn() {
                logAnalyticsEvent('giveaway_google_click')
                await this.GoogleSignIn({
                    becomeOwner: false,
                    redirect: false
                })
                await this.handleUserFlow()
            },

            async onFacebookSignIn() {
                logAnalyticsEvent('giveaway_fb_click')
                await this.FacebookSignIn({
                    becomeOwner: false,
                    redirect: false
                })
                await this.handleUserFlow()
            },

            openSocialLink(link) {
                logAnalyticsEvent('giveaway_soc_review_item_click')
                this.redirectToSocialMode = {
                    link: link
                }
            },

            confirmRedirectToSocial() {
                logAnalyticsEvent('giveaway_confirm_social_redirect')
                let link = this.redirectToSocialMode.link
                this.redirectToSocialMode = null
                let result = this.sendSocialClickToServer(this.settings.currentVoteUid, link.uid)
                if (result) {
                    this.$store.commit('rate/setGiveawayParticipates', true)
                }
                window.open(link.url, '_blank');
            },

            async handleUserFlow() {
                try {
                    await this.fetchUserInfo()
                    const response = await this.getRateInfoAction(this.settings.question_id)
                    this.$store.commit('rate/setGiveawayParticipates', response.data.giveaway.user_started)
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            underlayClick (e) {
                if(this.isClickOutOfBlock('popupModal__content', e.target)) {
                    this.showInfoModal = false
                }
            }

        },
    }
</script>

<style scoped>

.phone_input_wrapper {
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.phone_save {
    height: 37px;
    background-color: #ffffff;
    font-size: 16px;
    width: 80px;
    margin-left: 4px;
    display: flex;
    color: #2F2F2F;
    border-radius: 2px;
    justify-content: center;
    cursor: pointer;
}
.phone_save:active {
    background-color: #dcdcdc;
}
.phone_save span {
    margin: auto;
}
.phone_input {
    height: 37px;
    border: none;
    color: #2F2F2F;
    background-color: #ffffff;
    border-radius: 2px;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 16px;
    width: 150px;
    padding-top: 0;
    padding-bottom: 0;
}

.phone_input:focus {
    outline: none;
    border: none;
    border-bottom: 2px solid #3F405C;
}
.step_hint {
    color: white;
    font-size: 13px;
    width: 100%;
    text-align: center;
    padding-top: 12px;
    margin-bottom: 8px;
}
.step_hint.small{
    margin-bottom: 0;
}

    .modal-secondary-text {
        font-size: 12px;
        font-weight: 700;
        margin-top: 15px;
    }

    .custom-modal.leftAlign .modal-input {
        text-align: left;
    }
    .close-icon {
        position: absolute;
        right: 25px;
        z-index: 99999;
    }

    .confettiModal {
        position: absolute;
        top: -120px;
        left: 0 !important;
        width: 100%;
        overflow: hidden;
    }
    .confettiModal img {
        width: 650px;
    }
    .place {
        position: relative;
    }
    .place.img_wrapper {
        margin-top: 4px;
        margin-bottom: 12px;
    }
    .place_name {
        position: relative;
        text-align: center;
        font-family: Nunito;
        font-weight: 700;
    }
    .custom-modal .modal-title {
        font-size: 18px;
        font-weight: bold;
        color: #2F2F2F;
        text-align: center;
    }

    .custom-modal .modal-header {
        text-align: center;
        border: none;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .custom-modal.welcome-modal .modal-footer {
        flex-direction: column;
    }

    .custom-modal.welcome-modal .modal-footer > * {
        width: 100%;
        margin: 5px 0;
        text-decoration: none;
    }

    .custom-modal .modal-footer a {
        text-decoration: none;
    }

    .custom-modal .modal-footer {
        border: none;
    }

    .custom-modal .modal-message {
        font-size: 16px;
        color: #2F2F2F;
        max-width: 360px;
        margin: 15px auto 0;
    }

    .custom-modal {
        text-align: center;
    }

    .modal-input {
        margin-top: 15px;
    }

    .modal-input input:focus {
        border-color: #2F2F2F;
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    .custom-modal .btn {
        min-width: 140px;
        padding: 10px 12px;
        border-radius: 0;
        border: none;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
    }


    .custom-modal .btn:not(:disabled):not(.disabled):active,
    .custom-modal .btn:active,
    .custom-modal .btn:active:focus,
    .custom-modal .btn:focus {
        border-radius: 6px;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.24);
    }

    .custom-modal .modal-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto;
        background-size: cover;
        margin-bottom: 15px;
    }

    .custom-modal .btn.btn-primary {
        background: #2F2F2F;
        color: #ffffff;
    }

    /**/

    .full-width--btn.custom-modal .btn {
        width: 100%;
    }

    .giveaway__title {
        color: #3F405C;
        font-family: Nunito;
        font-size: 19px;
        font-weight: 900;
        letter-spacing: 1px;
        line-height: 25px;
        text-align: center;
        margin-top: 25px;
        position: relative;
    }

    .checkList__wrapper {
        margin-top: 40px;
    }

    .checkList__content {
        display: flex;
        justify-content: center;
        margin-bottom: 25px;
        align-items: center;
    }

    .content__number {
        color: #3F405C;
        font-family: Nunito;
        font-size: 18px;
        font-weight: 900;
        letter-spacing: 1.69px;
        margin-left: -10px;
        margin-right: 15px;
        width: 24px;
    }

    .content__text {
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 22px;
        width: 280px;
        text-align: start;
    }

    .login__wrapper {
        border-radius: 8px;
        background-color: #3F405C;
        width: 100%;
    }

    .loginBtn {
        display: flex;
        justify-content: space-around;
        padding: 24px 15px 16px 16px;
        height: 44px;
    }

    .login__title {
        padding-top: 20px;
        text-align: center;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 22px;
    }

    .loginBtnFacebook__wrapper {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background-color: #1976D2;
        padding: 12px 23px;
    }
    .loginBtnFacebook__wrapper:hover {
        cursor: pointer;
    }

    .loginBtnGoogle__wrapper {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background-color: #DD4B39;
        padding: 12px 32px;
    }
    .loginBtnGoogle__wrapper:hover {
        cursor: pointer;
    }

    .loginBtn__icon {
        padding-right: 4px;
        display: flex;
    }

    .loginBtn__text {
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
    }

    .cancel__wrapper {
        padding-top: 23px;
        padding-bottom: 15px;
    }
    .cancel__wrapper:hover {
        cursor: pointer;
    }

    .cancel__text {
        color: #2F2F2F;
        font-family:  Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
    }

    .reviewBtn {
        display: flex;
        justify-content: space-around;
        padding: 17px 15px 16px 16px;
    }

    .login__wrapper .review-btn {
        border-radius: 4px;
        padding: 12px 12px;
    }

    .login__wrapper .review-btn:hover {
        cursor: pointer;
    }

    .login__wrapper .review-btn.facebook-button {
        background-color: #1976D2;
    }

    .login__wrapper .review-btn.yelp-button {
        background-color: #FE5022;
    }

    .login__wrapper .review-btn.google-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.tripadvisor-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.instagram-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.vk-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.website-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.donate-button {
        background: #00a99e;
    }

    .login__wrapper .review-btn.adopt-button {
        background: #9d1c20;
    }

    .place_img_ga {
        margin: 1em auto 1em;
        /*border-radius: 50%;*/
        overflow: hidden;
        /*box-shadow: 0px 0px 0px 6px #fff, 0px 0px 7px 3px #555;*/
        z-index: 1;
        margin-bottom: 10px;
    }

    .place_img_ga img {
        min-height: 55px;
        margin: 0 auto;
        display: block;
        width: auto;
        height: 100%;
        object-fit: contain;
        max-height: 55px;
    }

    .finalStep {
        margin-top: 10px;
    }

    .finalStep__text {
        white-space: pre-line;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 22px;
        text-align: start;
        padding-left: 24px;
        padding-right: 24px;
        position: relative;
    }

    .closeBtn {
        margin-top: 32px;
        border-radius: 4px;
        background-color: #3F405C;
        padding: 12px 12px;
        margin-left: 24px;
        margin-right: 24px;
    }

    .closeBtn:hover {
        cursor: pointer;
    }

    .closeBtn__text {
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
    }
    .ambassador-benefits {
        text-align: center;
        font-size: 25px;
        color: #3F405C;
    }
    .ambassador-help {
        text-align: center;
        color: #3F405C;
    }
    .checkList__description {
        padding-left: 35px;
        padding-right: 35px;
        margin-bottom: 20px;
        font-size: 16px;
        color: #3F405C;
    }
    .description_text {
        padding-left: 16px;
        padding-right: 16px;
        margin-bottom: 4px;
        margin-top: 16px;
        text-align: center;
        font-size: 17px;
        color: #3F405C;
        line-height: 22px;
    }


    @media screen and (max-width: 1000px) {
        .full-width--btn.custom-modal .modal-footer button {
            width: 100%;
            margin: 0;
            margin-top: 3vw;
        }

        .full-width--btn.custom-modal .modal-footer {
            border: none;
            flex-direction: column-reverse;
            /* width: 100%; */
        }
    }
    @media screen and (max-width: 769px ) {
        .confettiModal {
            left: 15%;
        }
    }
    @media screen and (max-width: 426px) {
        .confettiModal {
            left: 0px;
            top: -55px;

        }
        .confettiModal img {
            width: 100%;
        }
        .giveaway__title {
            margin-top: 0px;
        }
        .checkList__wrapper {
            margin-top: 15px;
        }
        .checkList__content {
            margin-bottom: 15px;
            padding-left: 34px;
        }
        .checkList__description {
            padding-left: 24px;
            padding-right: 24px;
        }
        .loginBtn {
            padding-top: 15px;
        }
        .place_img_ga {
            margin-top: 0;
        }
        .closeBtn {
            margin-top: 15px;
        }
        .ambassador-benefits {
            font-size: 24px;
        }
    }
    @media screen and (max-width: 376px) {
        .loginBtnFacebook__wrapper {
            padding: 12px 15px;
        }
        .loginBtnGoogle__wrapper {
            padding: 12px 25px;
        }
        .content__text {
            margin-left: 15px;
        }
        .closeBtn {
            padding: 12px 12px;
        }
        .content__number {
            margin-left: 0;
        }
        .checkList__content {
            padding-left: 25px;
        }
    }
    @media screen and (max-width: 321px) {
        .loginBtnGoogle__wrapper {
            padding: 12px 5px;
        }
        .loginBtnFacebook__wrapper {
            padding: 12px 3px;
        }
        .giveaway__title {
            font-size: 16px;
        }
    }
    @media screen and (min-height: 550px) /*todo real 550, test 666| less than iphone 6/7/8*/ {
        .place {
            display: none;
        }
        .popupModal__content {
            margin: 3.75rem auto;
        }
    }
    @media screen and (min-height: 621px) { /*todo real 621, test 735| iphone 6/7/8 Plus and bigger */
        .place {
            display: none;
        }
        .popupModal__content {
            margin: 4.75rem auto;
        }
        .cancel__wrapper {
            padding-top: 15px;
            padding-bottom: 0px;
        }
    }
    @media screen and (min-height: 696px) { /*todo real 696, test 810| iphone X + larger*/
        .place {
            display: block;
            margin-top: 10px;
            margin-bottom: 0px;
        }
    }

</style>

<style>
    .custom-modal {
        overflow: hidden !important;
    }
</style>
